// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WUHx","label":"styles_label__1gK0m"};